// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__9Yhin","logo":"Footer_logo__HuMQ4","copyrightContainer":"Footer_copyrightContainer__VZyEm","link":"Footer_link__1b_Cb"};